import { sva } from "@stubhub/broadway-foundation/css";
import { eventGridListItemCalendarSlots } from "@stubhub/ensemble-discovery";

export const playoffCalendarBlockRecipe = sva({
  slots: eventGridListItemCalendarSlots,
  className: "playoffCalendarBlock",
  base: {
    container: {
      height: "[64px]",
      alignSelf: "center",
    },
    chinContent: {
      fontSize: "[8px]",
    },
  },
  variants: {
    state: {
      confirmed: {
        contentContainer: {
          paddingBlockStart: "primitives.50",
          paddingBlockEnd: "primitives.50",
        },
      },
      tbd: {},
    },
    eventState: {
      active: {
        contentSecondary: {
          color: "text.subtle",
        },
      },
      soldOut: {},
      comingSoon: {},
    },
  },
  defaultVariants: {
    state: "confirmed",
    eventState: "active",
  },
});
